import image1 from "./assets/image1.png"
import image2 from "./assets/image2.png"
import image3 from "./assets/image3.png"
import image4 from "./assets/image4.png"


const modelsData = [
  {
    name: "Qwen2.5-VL-32B-Instruct",
    overall: 99,
    images: [
      image1,
      image2
    ],
    description: "Qwen2.5-VL-32B-Instruct has emerged as the top performer in our tests. It excels in understanding complex documents, handling multilingual text, and preserving layouts. Its accuracy in extracting text from scanned documents, especially those with intricate layouts and mixed languages, is impressive. It also performs well with handwritten notes, making it a versatile choice for diverse OCR tasks.",
  },
  {
    name: "Gemini 2.5 Pro",
    overall: 98,
    description: "Gemini offers solid performance in OCR tasks, particularly with scanned documents and standard layouts. It handles multilingual text reasonably well and provides good accuracy for most use cases. However, it falls slightly short when dealing with highly complex layouts or handwritten notes compared to the above two models.",
  },
  {
    name: "Claude 3.7 Sonnet",
    overall: 95,
    images: [
      image3, image4
    ],
    imageLabels: [
      "Eg: Bank Statement OCR",
      "Output:"
    ],
    description: "Claude 3.7 sonnet follows closely behind Qwen2.5-VL-7B-Instruct. It demonstrates strong capabilities in text recognition and context understanding. While it may not match Qwen's performance in the most complex layouts, it still delivers high accuracy and reliability across a wide range of documents.",
   
  },
  {
    name: "GPT 4o",
    overall: 94,
    description: "GPT 4o is known for its language understanding capabilities, which translate well into OCR tasks. It can accurately extract and interpret text from various documents. While it may not be the fastest option, its reliability and accuracy make it a strong contender for many OCR applications.",
   
  },
  {
    name: "Mistral Small",
    overall: 92,
    description: "Mistral has made significant strides in document understanding, particularly with complex elements like tables, equations, and images. However, in our tests, it didn't quite reach the accuracy levels of the other models, especially in handling handwritten text and certain multilingual documents. Also, we noticed Mistral hallucinating when trying to read Indian ID card documents and replacing it with dummy text.",
    note: "We noticed Mistral hallucinating when trying to read Indian ID card documents and replacing it with dummy text."
  }
];

export default modelsData;